import Flex from '@components/Layout/Flex';
import { styled } from '@mui/system';
const SectionContent = styled(Flex) `
  padding: ${({ theme }) => theme.spacing(2.5)};
  flex-direction: column;
`;
export default SectionContent;
